import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import axios from '../../plugins/axios';

import Paginate from '../mixins/paginate';
import PageBanner from '../PageBanner.vue';
import PageLimiter from '../PageLimiter.vue';
import Breadcrumbs from '../Breadcrumbs.vue';
import TagNav from '../TagNav.vue';
import FilterBar from '../FilterBar.vue';
import Btn from '../Btn.vue';
import IconArrow from '../IconArrow.vue';
import PageOverlay from '../PageOverlay.vue';
import Vacancy from '../Vacancy.vue';

export default {
	name: 'PageCareer',

	components: {
		PageBanner: PageBanner,
		PageLimiter: PageLimiter,
		Breadcrumbs: Breadcrumbs,
		TagNav: TagNav,
		FilterBar: FilterBar,
		Btn: Btn,
		IconArrow: IconArrow,
		PageOverlay: PageOverlay,
		Vacancy: Vacancy
	},

	props: {
		page: {
			type: Object,
			default: function _default() {
				return {};
			}
		},

		crumbs: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},

	data: function data() {
		return {
			swiperOptions: {
				slidesPerView: 2,
				centeredSlides: true,
				spaceBetween: 32,

				speed: 1800,
				loop: true,

				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},

				breakpoints: {
					620: {
						slidesPerView: 'auto',
						centeredSlides: false,
						spaceBetween: 16
					},

					1024: {
						slidesPerView: 'auto',
						spaceBetween: 32
					}
				}
			},

			itemsData: {},
			vacancy: {}
		};
	},


	computed: {
		lang: function lang() {
			return this.$store.state.settings.lang;
		},
		count: function count() {
			return this.itemsData.count + ' ' + this.$lang('vacancy', this.itemsData.count, this.$store.state.settings.lang);
		},
		basePath: function basePath() {
			var str = this.$route.path;

			if (this.tag) str = str + '?tag=' + this.tag;
			if (this.filter) str = str + '&filter=' + this.filter;

			return str;
		},
		tag: function tag() {
			return this.$route.query.tag || 'all';
		},
		filter: function filter() {
			return this.$route.query.filter;
		},
		currVacancy: function currVacancy() {
			return this.page.vacancy || this.vacancy;
		}
	},

	methods: {
		getVacancy: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
				var url, data;
				return _regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								url = 'vacancy?code=' + this.$route.query.vacancy + '&lang=' + this.$route.params.lang;
								_context.next = 3;
								return axios.get(url);

							case 3:
								data = _context.sent.data;

								this.vacancy = data || {};

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function getVacancy() {
				return _ref.apply(this, arguments);
			}

			return getVacancy;
		}()
	},

	watch: {
		'$route.query.vacancy': function $routeQueryVacancy(val) {
			if (val) this.getVacancy();
		}
	},

	created: function created() {
		this.itemsData = this.page.itemsData;
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageCareer.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/pages/PageCareer.vue
// module chunks = 0